import { container } from '../lib/DIContainer';
import { DI } from '@intigral/constant/config/DIContainer';
import { IAuthService } from '../lib/application/services/AuthService';
import { STORE_NAME, COOKIE_NAMES } from '@intigral/constant';
import { deleteCookie, setCookie } from '@intigral/utils/lib/browser-storage/cookie';
import { remove, clearAll, removeSession, set } from '@intigral/utils/lib/browser-storage/localStorage';

export const refreshAuthTokenApi = async () => {
    const userInfo = JSON.parse(window.localStorage.getItem(STORE_NAME.USER) || 'null');
    if (userInfo?.isGuest) {
        throw new Error('Auth token refresh is not allowed for guest browse sessions');
    }
    const authService = container.resolve<IAuthService>(DI.SERVICES.IAuthService);
    const userData = await authService.refreshAuthToken(
        userInfo.username,
        userInfo.authToken,
        userInfo.identityToken,
        userInfo.authSign
    );
    if (!userData.authToken) {
        throw new Error('Invalid used data returned while refreshing token. Data:' + JSON.stringify(userData));
    }
    set(STORE_NAME.USER, { ...userInfo, ...userData });
    const authData = {
        u: userData.username,
        i: userData.identityToken,
        a: userData.apiKey,
        t: userData.authToken,
        s: userData.authSign,
    };
    const baseEncodedToken = btoa(JSON.stringify(authData));
    setCookie(COOKIE_NAMES.USER_SESSION, baseEncodedToken, 30, false, true);
    return userData;
};

export const clearLocalDataOnLogout = () => {
    remove(STORE_NAME.USER);
    remove(STORE_NAME.USER);
    remove(STORE_NAME.USERNAME);
    remove(STORE_NAME.DEVICE);
    remove(STORE_NAME.LIVETV);
    remove(STORE_NAME.USER_PROFILE_LIST);
    remove(STORE_NAME.SELECTED_PROFILE);
    remove(STORE_NAME.REFRESH_TOKEN_ATTEMPS);
    clearAll();
    deleteCookie(COOKIE_NAMES.USER_SESSION);
    deleteCookie(COOKIE_NAMES.USER_AUTH_TOKEN);
    deleteCookie(COOKIE_NAMES.USER_API_KEY);
    removeSession(STORE_NAME.SUB_STATES);
};
